import { useParams, Link, Navigate } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { BLOG_POSTS, BLOG_CATEGORIES } from '../data/blogPosts';
import { translations } from '../translations';

export default function BlogCategoryPage({ language, setLanguage }) {
  const { category } = useParams();
  const t = translations[language];

  const cat = BLOG_CATEGORIES.find(c => c.key === category);
  if (!cat) return <Navigate to="/blog" replace />;

  const filtered = BLOG_POSTS.filter(p => p.category === category);

  return (
    <div className="blog-page" data-testid="blog-category-page">
      <SEOHead
        title={`${cat.label} Istanbul | Viaturkey`}
        description={`Read our latest articles about ${cat.label.toLowerCase()} in Istanbul. Expert guides and travel tips by Viaturkey.`}
        canonical={`https://viaturkey.net/blog/category/${category}`}
      />
      <Header language={language} t={t} />

      <section className="blog-hero" data-testid="blog-hero">
        <div className="blog-hero-content">
          <h1>{cat.label}</h1>
          <p>Expert guides and travel tips for your Istanbul journey</p>
        </div>
      </section>

      <section className="blog-categories" data-testid="blog-categories">
        <Link to="/blog" className="blog-cat-btn">All Posts</Link>
        {BLOG_CATEGORIES.filter(c => c.key !== 'all').map(c => (
          <Link key={c.key} to={`/blog/category/${c.key}`} className={`blog-cat-btn ${c.key === category ? 'active' : ''}`}>{c.label}</Link>
        ))}
      </section>

      <section className="blog-grid" data-testid="blog-grid">
        {filtered.length === 0 && <p style={{textAlign:'center',padding:'2rem',color:'#64748b'}}>No posts in this category yet.</p>}
        {filtered.map(post => (
          <article key={post.slug} className="blog-card" data-testid={`blog-card-${post.slug}`}>
            <Link to={`/blog/${post.slug}`}>
              <img src={post.thumbnail} alt={post.title} loading="lazy" className="blog-card-img" />
            </Link>
            <div className="blog-card-body">
              <Link to={`/blog/category/${post.category}`} className="blog-card-cat">{BLOG_CATEGORIES.find(c => c.key === post.category)?.label}</Link>
              <h2 className="blog-card-title"><Link to={`/blog/${post.slug}`}>{post.title}</Link></h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <div className="blog-card-meta">
                <time>{new Date(post.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</time>
                <span>{post.readTime} read</span>
              </div>
              <Link to={`/blog/${post.slug}`} className="blog-card-link" data-testid={`read-more-${post.slug}`}>Read More</Link>
            </div>
          </article>
        ))}
      </section>

      <Footer t={t} />
    </div>
  );
}
